<template>
    <div class="more-options-wrapper" :class="{'ios-transform': getDeviceInUse === 'ios'}">
        <dropdown-more-options
		:options="value"
		@showingMoreOptions="emit('showingMoreOptions', $event)"
		@clicked="emit('moreOptionsClicked', $event)"/>
    </div>
</template>

<script setup>
import DropdownMoreOptions from '@/components/generic/dropdowns/moreOptions/MoreOptions'

/* Store */
import { mapGetters } from '@/store/helpers/mappers'
const { getDeviceInUse } = mapGetters()
/* Emmitters */
const emit = defineEmits(['showingMoreOptions', 'moreOptionsClicked'])

/** Props received:
@value {Array} each item is an Object
	- id { String, Number }
	- text { String }
	- icon { String }
	- variant { String } can be [primary (default), secondary, negative]
	- callbackFunction { Function }
*/
const props = defineProps({
	value: Array
})
</script>

<style lang="scss" scoped>
.more-options-wrapper {
    width: 100%;
    height: 100%;
    position: relative;

	display: flex;
	flex-shrink: 0;
	flex-direction: row;
	align-items: center;
	justify-content: center;

	.dropdown-wrapper {
		width: 100%;
		height: 100%;

		align-items: center;
		justify-content: center;
		text-align: center;

		:deep(.dropdown-content) {
			height: 100%;
			display: flex;
			align-items: center;

			.open-more-options-button {
				width: 100%;
				height: 100%;
				padding-top: 3px;

				align-items: center;
				justify-content: center;
				display: flex;

				:deep(.open-more-options-button) {
					transform: rotate(90deg);
				}
			}

			.dropdown-animation-wrapper {
				top: 6px;
				right: 12px;
			}
		}
	}
}
</style>
